import api from '../../services/api';

export const getPosRestaurantBootstrap = async () => {
  const response = await api.get('/pos-restaurant/api/bootstrap/');
  return response.data;
};

export const getRestaurantLandingData = async () => {
  const response = await api.get('/pos-restaurant/api/landing/');
  return response.data;
};

export const getPosRestaurantSettings = async () => {
  const response = await api.get('/pos-restaurant/api/settings/');
  return response.data;
};

export const updatePosRestaurantSettings = async (payload) => {
  const response = await api.put('/pos-restaurant/api/settings/', payload);
  return response.data;
};

export const createPosOrder = async (payload) => {
  const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
  const response = await api.post('/pos-restaurant/api/orders/', payload, isFormData
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : undefined);
  return response.data;
};

export const updatePosOrder = async (orderId, payload) => {
  const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
  const response = await api.put(`/pos-restaurant/api/orders/${orderId}/`, payload, isFormData
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : undefined);
  return response.data;
};

export const deletePosOrder = async (orderId) => {
  await api.delete(`/pos-restaurant/api/orders/${orderId}/`);
};

export const getPosOrders = async (params = {}) => {
  const response = await api.get('/pos-restaurant/api/orders/', { params });
  return response.data;
};

export const getPosOrderPayments = async (params = {}) => {
  const response = await api.get('/pos-restaurant/api/payments/', { params });
  return response.data;
};

export const createPosOrderPayment = async (payload) => {
  const response = await api.post('/pos-restaurant/api/payments/', payload);
  return response.data;
};

export const updatePosOrderPayment = async (paymentId, payload) => {
  const response = await api.patch(`/pos-restaurant/api/payments/${paymentId}/`, payload);
  return response.data;
};

export const deletePosOrderPayment = async (paymentId) => {
  const response = await api.delete(`/pos-restaurant/api/payments/${paymentId}/`);
  return response.data;
};

export const getPosOrderDetail = async (orderId) => {
  const response = await api.get(`/pos-restaurant/api/orders/${orderId}/`);
  return response.data;
};

export const getPosOrderAuditLogs = async (orderId) => {
  const response = await api.get(`/pos-restaurant/api/orders/${orderId}/audit-logs/`);
  return response.data;
};

export const getPosOrderEbillContext = async (orderId) => {
  const response = await api.get(`/pos-restaurant/api/orders/${orderId}/send-ebill/`);
  return response.data;
};

export const sendPosOrderEbill = async (orderId, payload) => {
  const response = await api.post(`/pos-restaurant/api/orders/${orderId}/send-ebill/`, payload);
  return response.data;
};

export const printPosOrderInvoice = async (orderId) => {
  const response = await api.get(`/pos-restaurant/api/orders/${orderId}/print-invoice/`, {
    responseType: 'blob',
  });
  return response.data;
};

export const fetchPosOrderInvoicePdfBlob = printPosOrderInvoice;

export const fetchPosOrderDraftInvoiceDefaults = async (orderId) => {
  const response = await api.get(`/pos-restaurant/api/orders/${orderId}/draft-invoice/defaults/`);
  return response.data;
};

export const fetchPosOrderDraftInvoicePdfBlob = async (orderId, draftPayload = {}) => {
  const response = await api.post(`/pos-restaurant/api/orders/${orderId}/draft-invoice/`, draftPayload, {
    responseType: 'blob',
  });
  return response.data;
};

export const downloadPosOrderInvoice = async (orderId, fallbackReference = '') => {
  const response = await api.get(`/pos-restaurant/api/orders/${orderId}/print-invoice/`, {
    responseType: 'blob',
  });
  const blob = response.data;
  const disposition = response.headers['content-disposition'];
  const parsedFilename = disposition?.match(/filename="?([^";]+)"?/)?.[1];
  const safeReference = String(fallbackReference || '').replace(/^POS-/i, '') || String(orderId || 'order');
  const filename = parsedFilename || `RestaurantInvoice_${safeReference}.pdf`;
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  window.URL.revokeObjectURL(url);
  anchor.remove();
};

export const getConfigurationTaxRules = async (params = {}) => {
  const response = await api.get('/configuration/api/tax-rules/', { params });
  return response.data?.tax_rules || [];
};

export const createPosTable = async (payload) => {
  const response = await api.post('/pos-restaurant/api/tables/', payload);
  return response.data;
};

export const updatePosTable = async (tableId, payload) => {
  const response = await api.put(`/pos-restaurant/api/tables/${tableId}/`, payload);
  return response.data;
};

export const deletePosTable = async (tableId) => {
  await api.delete(`/pos-restaurant/api/tables/${tableId}/`);
};

export const getPosRoomConfigs = async () => {
  const response = await api.get('/pos-restaurant/api/room-configs/');
  return response.data;
};

export const updatePosRoomConfigs = async (enabledRoomIds = []) => {
  const response = await api.put('/pos-restaurant/api/room-configs/', {
    enabled_room_ids: enabledRoomIds,
  });
  return response.data;
};

export const getPosQrContext = async ({ targetType, targetId }) => {
  const response = await api.get('/pos-restaurant/api/qr/context/', {
    params: {
      target_type: targetType,
      target_id: targetId,
    },
  });
  return response.data;
};

/**
 * Read-only property branding (logo + public site slug).
 * Used only to decorate the downloadable QR stand artwork.
 */
export const getPosQrBrandingProfile = async () => {
  const response = await api.get('/distribution/api/nexastay-theme/');
  return response.data;
};

export const getPosOpenQrBootstrap = async ({ hotelId, targetType, targetId, qrToken }) => {
  const response = await api.get('/pos-restaurant/api/open/bootstrap/', {
    params: {
      hotel_id: hotelId,
      target_type: targetType,
      target_id: targetId,
      qr_token: qrToken,
    },
  });
  return response.data;
};

export const getPosOpenQrOrders = async ({ hotelId, targetType, targetId, qrToken, status }) => {
  const response = await api.get('/pos-restaurant/api/open/orders/', {
    params: {
      hotel_id: hotelId,
      target_type: targetType,
      target_id: targetId,
      qr_token: qrToken,
      status,
    },
  });
  return response.data;
};

export const createPosOpenQrOrder = async (payload) => {
  const response = await api.post('/pos-restaurant/api/open/orders/', payload);
  return response.data;
};

export const createPosMenuCategory = async (payload) => {
  const response = await api.post('/pos-restaurant/api/menu-categories/', payload);
  return response.data;
};

export const updatePosMenuCategory = async (categoryId, payload) => {
  const response = await api.put(`/pos-restaurant/api/menu-categories/${categoryId}/`, payload);
  return response.data;
};

export const deletePosMenuCategory = async (categoryId) => {
  await api.delete(`/pos-restaurant/api/menu-categories/${categoryId}/`);
};

export const createPosMenuVariation = async (payload) => {
  const response = await api.post('/pos-restaurant/api/menu-variations/', payload);
  return response.data;
};

export const updatePosMenuVariation = async (variationId, payload) => {
  const response = await api.put(`/pos-restaurant/api/menu-variations/${variationId}/`, payload);
  return response.data;
};

export const deletePosMenuVariation = async (variationId) => {
  await api.delete(`/pos-restaurant/api/menu-variations/${variationId}/`);
};

export const createPosMenuItem = async (payload) => {
  const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
  const response = await api.post('/pos-restaurant/api/menu-items/', payload, isFormData
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : undefined);
  return response.data;
};

export const updatePosMenuItem = async (menuItemId, payload) => {
  const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
  const response = await api.put(`/pos-restaurant/api/menu-items/${menuItemId}/`, payload, isFormData
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : undefined);
  return response.data;
};

export const deletePosMenuItem = async (menuItemId) => {
  await api.delete(`/pos-restaurant/api/menu-items/${menuItemId}/`);
};

export const extractPosMenuAiData = async ({ file, url, signal } = {}) => {
  if (url && !file) {
    const response = await api.post(
      '/pos-restaurant/api/menu/ai-extract/',
      { url },
      { timeout: 180000, signal }
    );
    return response.data;
  }
  const formData = new FormData();
  if (file) formData.append('file', file);
  if (url) formData.append('url', url);
  const response = await api.post('/pos-restaurant/api/menu/ai-extract/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 180000,
    signal,
  });
  return response.data;
};

export const commitPosMenuAiData = async (menuPayload) => {
  const response = await api.post(
    '/pos-restaurant/api/menu/ai-commit/',
    {
      menu: menuPayload,
    },
    { timeout: 300000 }
  );
  return response.data;
};
